import type { ColumnType } from "../common/description";

export const titleProperties: ReadonlyArray<string> = ["title", "name", "summary", "caption"];
export const phoneProperties: readonly string[] = ["phone", "mobile"];
export const imageProperties: ReadonlyArray<string> = [
    "photo",
    "photos",
    "image",
    "images",
    "picture",
    "pictures",
    "img",
    "imgs",
    "pic",
    "pics",
    "gallery",
    "carousel",
];

export function isImageType(t: ColumnType, withEmoji: boolean, allowArrayColumn: boolean): boolean {
    return (
        t.kind === "image-uri" ||
        (withEmoji && t.kind === "emoji") ||
        (allowArrayColumn && t.kind === "array" && t.items.kind === "image-uri")
    );
}
